<span *ngIf="tarifficationPeriod == 1">
  {{ tarifficationPeriodPrice | formatCost }} х {{ duration }} мин.
</span>
<span *ngIf="tarifficationPeriod > 1">
  {{ tarifficationPeriodPrice | formatCost }} х {{ periodsCount }} по {{ tarifficationPeriod }} мин.
</span>
<span *ngIf="multiplier > 1">X {{ multiplier }}</span>
= {{ cost | formatCost }}
